module.exports = __webpack_public_path__ + "8f58f3721bc8f11a225af8f3f145de4b.jpg";